import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClassroomType } from '../../../types/Classroom';

const initialState:ClassroomType = {
  description: '',
  status: false,
  idClassroomType: '',
  idDepartament: '',
  idFaculty: ''
}

const classroomSlice = createSlice({
  name: "classroomForm",
  initialState,
  reducers: {
    setClassroomData:(state, action:PayloadAction<ClassroomType>)=>({...state, ...action.payload}), 
    resetClassroomData :()=>({...initialState})
  }
});

export const {setClassroomData, resetClassroomData} = classroomSlice.actions

export default classroomSlice.reducer